import React,{useContext} from 'react';
import Context from '../../../Context';
  
function LicenseText(){
    const cx=useContext(Context);
    cx.breadCrumbsAdd(cx.t("pages.license"));
    return(
        <div className="card card-custom gutter-b">            
            <div className="card-body">
                В настоящий момент текст лицензии отсутствует
            </div>
        </div>
    )
}
export default LicenseText;